// import { RouteObject } from 'react-router-dom';

// Route tipi tanımı
// export interface AppRouteObject extends RouteObject {
//     isPrivate?: boolean;
//     isPublic?: boolean;
// }

// Routes will be added here
/*
Routes to be implemented:

1. Authentication Routes (Public):
- /login - Login page
- /forgot-password - Forgot password page
- /reset-password - Reset password page

2. Dashboard Routes (Private):
- / - Main dashboard
- /profile - User profile
- /settings - User settings

3. Company Management Routes (Private):
- /companies - Company list
- /companies/new - Create new company
- /companies/:id - Company details
- /companies/:id/edit - Edit company
- /companies/:id/settings - Company settings

4. Branch Management Routes (Private):
- /branches - Branch list
- /branches/new - Create new branch
- /branches/:id - Branch details
- /branches/:id/edit - Edit branch

5. Department Management Routes (Private):
- /departments - Department list
- /departments/new - Create new department
- /departments/:id - Department details
- /departments/:id/edit - Edit department

6. Employee Management Routes (Private):
- /employees - Employee list
- /employees/new - Create new employee
- /employees/:id - Employee details
- /employees/:id/edit - Edit employee

7. Shift Management Routes (Private):
- /shifts - Shift list
- /shifts/new - Create new shift
- /shifts/:id - Shift details
- /shifts/:id/edit - Edit shift

8. Leave Management Routes (Private):
- /leaves - Leave requests list
- /leaves/new - Create new leave request
- /leaves/:id - Leave request details

9. Excuse Management Routes (Private):
- /excuses - Excuse list
- /excuses/new - Create new excuse
- /excuses/:id - Excuse details

10. Report Routes (Private):
- /reports/performance - Performance reports
- /reports/attendance/daily - Daily attendance reports
- /reports/attendance/weekly - Weekly attendance reports
- /reports/attendance/monthly - Monthly attendance reports
- /reports/department - Department reports
*/

//export const all_routes: AppRouteObject[] = [];

export const all_routes = {
  // dashboard routes
  adminDashboard: "/index",
  employeeDashboard: "/employee-dashboard",
  leadsDashboard: "/leads-dashboard",
  dealsDashboard: "/deals-dashboard",
  //Application routes
  chat: "/application/chat",
  voiceCall: "/application/voice-call",
  videoCall: "/application/video-call",
  outgoingCall: "/application/outgoing-call",
  incomingCall: "/application/incoming-call",
  callHistory: "/application/call-history",
  todo: "/application/todo",
  TodoList: "/application/todo-list",
  email: "/application/email",
  EmailReply: "/application/email-reply",
  audioCall: "/application/audio-call",
  fileManager: "/application/file-manager",
  socialFeed: "/application/social-feed",
  kanbanView: "/application/kanban-view",
  invoice: "/application/invoices",

  ////////////////////////
  superAdminSubscriptions: "/admin/subscriptions",
  superAdminPackages: "/admin/packages",
  superAdminPackagesGrid: "/admin/packages-grid",
  superAdminDomain: "/admin/domain",
  superAdminPurchaseTransaction: "/admin/purchase-transaction",
  ////////////////////////
  //super admin module
  superAdminDashboard: "/admin/dashboard",
  superAdminCompanyDetails: "/admin/company-details/:id",
  superAdminCompanyCreate: "/admin/company-create",
  superAdminCompanies: "/admin/companies",
  superAdminAboutUs: "/superadmin/about-us",
  superAdminCompanyEdit: "/superadmin/company-edit/:id",
  superAdminDashboard2: "/superadmin/dashboard",

  // Referral Campaign routes
  superAdminReferralCampaigns: "/super-admin/referral-campaigns",
  superAdminReferralCampaignCreate: "/super-admin/referral-campaigns/new",
  superAdminReferralCampaignEdit: "/super-admin/referral-campaigns/:id/edit",
  superAdminReferralCampaignDetails: "/super-admin/referral-campaigns/:id",

  // Coupon routes
  coupons: "/superadmin/coupons",
  createCoupon: "/superadmin/create-coupon",
  editCoupon: "/superadmin/coupons/:id/edit",
  couponDetails: "/superadmin/coupons/:id",

  // Payment routes
  paymentReports: "/superadmin/payment-reports",
  companyPaymentHistory: "/companies/payment-history",

  // Product routes
  productManagement: "/superadmin/product-management",
  parasutInvoices: "/superadmin/parasut-invoices",

  calendar: "/calendar",
  dataTables: "/data-tables",
  tablesBasic: "/tables-basic",
  notes: "/notes",

  branches: "/branches",
  shift: "/shift",
  //page module
  starter: "/starter",
  profile: "/pages/profile",
  gallery: "/gallery",
  searchresult: "/search-result",
  timeline: "/timeline",
  pricing: "/pricing",
  comingSoon: "/coming-soon",
  underMaintenance: "/under-maintenance",
  underConstruction: "/under-construction",
  error404: "/error-404",
  error500: "/error-500",
  apikey: "/api-keys",
  privacyPolicy: "/privacy-policy",
  termscondition: "/terms-condition",

  // auth routes routes
  login2: "/login",
  login: "/login-2",
  login3: "/create-company",
  register2: "/register",
  register: "/register-2",
  register3: "/register-3",
  forgotPassword2: "/forgot-password",
  forgotPassword: "/forgot-password-2",
  forgotPassword3: "/forgot-password-3",
  twoStepVerification2: "/two-step-verification",
  twoStepVerification: "/two-step-verification-2",
  twoStepVerification3: "/two-step-verification-3",
  success: "/success",
  emailVerification2: "/email-verification",
  emailVerification: "/email-verification-2",
  emailVerification3: "/email-verification-3",
  lockScreen: "/lock-screen",
  resetPassword2: "/reset-password",
  resetPassword: "/reset-password-2",
  resetPassword3: "/reset-password-3",
  resetPasswordSuccess2: "/success",
  resetPasswordSuccess: "/success-2",
  resetPasswordSuccess3: "/success-3",

  //ui routes
  alert: "/ui-alert",
  accordion: "/ui-accordion",
  avatar: "/ui-avatar",
  badges: "/ui-badges",
  border: "/ui-border",
  breadcrums: "/ui-breadcrums",
  button: "/ui-buttons",
  buttonGroup: "/ui-button-group",
  cards: "/ui-cards",
  carousel: "/ui-carousel",
  colors: "/ui-colors",
  dropdowns: "/ui-dropdowns",
  grid: "/ui-grid",
  images: "/ui-images",
  lightbox: "/ui-lightbox",
  media: "/ui-media",
  modals: "/ui-modals",
  navTabs: "/ui-navtabs",
  offcanvas: "/ui-offcanvas",
  pagination: "/ui-pagination",
  placeholder: "/ui-placeholder",
  popover: "/ui-popover",
  progress: "/ui-progress",
  rangeSlider: "/ui-rangeslider",
  spinner: "/ui-spinner",
  sweetalert: "/sweetalert",
  toasts: "/ui-toasts",
  tooltip: "/ui-tooltip",
  typography: "/ui-typography",
  video: "/ui-video",
  clipboard: "/ui-clipboard",
  counter: "/ui-counter",
  dragandDrop: "/ui-drag-drop",
  rating: "/ui-rating",
  ribbon: "/ui-ribbon",
  stickyNotes: "/ui-sticky-notes",
  textEditor: "/ui-text-editor",
  timeLine: "/ui-timeline",
  scrollBar: "/ui-scrollbar",
  apexChart: "/ui-apexchart",
  primeChart: "/ui-prime-chart",
  chartJs: "/ui-chart-js",

  chart: "/ui-chartjs",
  featherIcons: "/ui-feather-icon",
  falgIcons: "/ui-flag-icon",
  fontawesome: "/ui-fontawesome",
  materialIcon: "/ui-material-icon",
  pe7icon: "/ui-icon-pe7",
  simpleLineIcon: "/ui-simpleline",
  themifyIcon: "/ui-themify",
  typicon: "/ui-typicon",
  weatherIcon: "/ui-weather-icon",
  basicInput: "/forms-basic-input",
  checkboxandRadion: "/form-checkbox-radios",
  inputGroup: "/form-input-groups",
  gridandGutters: "/form-grid-gutters",
  formSelect: "/form-select",
  formMask: "/form-mask",
  fileUpload: "/form-fileupload",
  horizontalForm: "/form-horizontal",
  formPicker: "/form-pickers",
  verticalForm: "/form-vertical",
  floatingLable: "/form-floating-labels",
  formValidation: "/form-validation",
  reactSelect: "/select",
  formWizard: "/form-wizard",
  iconicIcon: "/icon-ionic",
  sortable: "/ui-sortable",
  swiperjs: "/ui-swiperjs",
  bootstrapIcons: "/icon-bootstrap",
  RemixIcons: "/icon-remix",
  FlagIcons: "/icon-flag",

  //base-ui
  uiAlerts: "/ui-alerts",
  uiAccordion: "/ui-accordion",
  uiAvatar: "/ui-avatar",
  uiBadges: "/ui-badges",
  uiBorders: "/ui-borders",
  uiButtons: "/ui-buttons",
  uiButtonsGroup: "/ui-buttons-group",
  uiBreadcrumb: "/ui-breadcrumb",
  uiCards: "/ui-cards",
  uiCarousel: "/ui-carousel",
  uiColor: "/ui-color",
  uiDropdowns: "ui-dropdowns",

  //Maps
  mapLeaflet: "/map-leaflet",

  // settings routes
  customFields: "/app-settings/custom-fields",
  invoiceSettings: "/app-settings/invoice-settings",

  currencies: "/financial-settings/currencies",
  paymentGateways: "/financial-settings/payment-gateways",
  taxRates: "/financial-settings/tax-rates",

  schoolSettings: "/academic-settings/school-settings",
  religion: "/academic-settings/religion",

  connectedApps: "/general-settings/connected-apps",
  notificationssettings: "/general-settings/notifications-settings",
  profilesettings: "/general-settings/profile-settings",
  securitysettings: "/general-settings/security-settings",

  bussinessSettings: "/website-settings/bussiness-settings",
  seoSettings: "/website-settings/seo-settings",
  localizationSettings: "/website-settings/localization-settings",
  prefixes: "/website-settings/prefixes",
  preference: "/website-settings/preferences",
  appearance: "/website-settings/appearance",
  authenticationSettings: "/website-settings/authentication-settings",
  aiSettings: "/website-settings/ai-settings",

  salarySettings: "/app-settings/salary-settings",
  approvalSettings: "/app-settings/approval-settings",
  leaveType: "/app-settings/leave-type",

  banIpAddress: "/other-settings/ban-ip-address",
  customCss: "/other-settings/custom-css",
  customJs: "/other-settings/custom-js",
  cronjob: "/other-settings/cronjob",
  Cronjobschedule: "/other-settings/cronjob-schedule",
  storage: "/other-settings/storage-settings",
  backup: "/other-settings/backup",
  clearcache: "/other-settings/clear-cache",

  emailSettings: "/system-settings/email-settings",
  emailTemplates: "/system-settings/email-templates",
  gdprCookies: "/system-settings/gdpr-cookies",
  smsSettings: "/system-settings/sms-settings",
  smsTemplate: "/system-settings/sms-template",
  otpSettings: "/system-settings/otp-settings",
  maintenanceMode: "/system-settings/maintenance-mode",

  socialAuthentication: "/website-settings/social-authentication",
  language: "/website-settings/language",
  addLanguage: "/website-settings/add-language",
  languageWeb: "/website-settings/language-web",
  localization: "/website-settings/localization",

  //content routes
  pages: "/content/pages",
  countries: "countries",
  states: "/content/states",
  cities: "/content/cities",
  testimonials: "testimonials",
  faq: "faq",

  // blog
  blogs: "blogs",
  blogCategories: "blog-categories",
  blogComments: "blog-comments",
  blogTags: "blog-tags",

  //userManagement routes
  deleteRequest: "/user-management/delete-request",
  rolesPermissions: "/user-management/roles-permissions",
  manageusers: "/user-management/manage-users",
  permissions: "/user-management/permissions",

  //support routes
  contactMessages: "/support/contact-messages",
  tickets: "/tickets/ticket-list",
  ticketGrid: "/tickets/ticket-grid",
  ticketList: "/support/ticket-list",
  ticketDetails: "/tickets/ticket-details/:id",

  // Performance

  performanceIndicator: "/performance/performance-indicator",
  performanceReview: "/performance/performance-review",
  performanceAppraisal: "/preformance/performance-appraisal",
  goalTracking: "/performance/goal-tracking",
  goalType: "/performance/goal-type",

  // Training

  trainingList: "/training/training-list",
  trainers: "/training/trainers",
  trainingType: "/training/training-type",

  // membership routes
  membershipplan: "/membership-plans",
  membershipAddon: "/membership-addons",
  membershipTransaction: "/membership-transactions",

  layoutDefault: "/layout-default",
  layoutMini: "/layout-mini",
  layoutRtl: "/layout-rtl",
  layoutBox: "/layout-box",
  layoutDark: "/layout-dark",
  Horizontal: "/layout-horizontal",
  Detached: "/layout-detached",
  Hovered: "/layout-hovered",
  Boxed: "/layout-box",
  Modern: "/layout-modern",
  TwoColumn: "/layout-twocolumn",
  HorizontalSingle: "/layout-horizontal-single",
  HorizontalOverlay: "/layout-horizontal-overlay",
  HorizontalBox: "/layout-horizontal-box",
  MenuAside: "/layout-horizontal-sidemenu",
  Transparent: "/layout-transparent",
  WithoutHeader: "/layout-without-header",
  RTL: "/layout-rtl",
  Dark: "/layout-dark",

  // finance & accounts routes
  accountsIncome: "/accounts/accounts-income",
  accountsInvoices: "/accounts/accounts-invoices",
  accountsTransactions: "/accounts/accounts-transactions",
  expense: "/accounts/expense",
  expenseCategory: "/accounts/expense-category",

  addInvoice: "/accounts/add-invoice",
  editInvoice: "/accounts/edit-invoice",
  categories: "/accounting/categories",
  budgets: "/accounting/budgets",
  budgetexpenses: "/accounting/budgets-expenses",
  budgetrevenues: "accounting/budget-revenues",
  attendanceReport: "/reports/attendance",
  attendance: "/attendance",
  breakReport: "/reports/break",
  companySettings: "/company-settings",
  referralProgram: "/admin/referral-program",
  employeeReport: "/reports/employee",
  leaveReport: "/reports/leave",
  shiftReport: "/reports/shift",
  ticketReport: "/reports/ticket",
  timesheetReport: "/reports/timesheet",
  employeereport: "/employee-report",
  notification: "/notification",
  notificationList: "/notification/list",
  // Belgeler sayfası
  documents: "/reports/documents",

  // Zimmet yönetimi (Inventory)
  assets: "/inventory",
  assetDetails: "/inventory/:id",
  createAsset: "/inventory/create",
  editAsset: "/inventory/:id/edit",
  userAssets: "/inventory/user/:userId",

  // Yemek Yönetimi
  meals: "/meals",
  mealsList: "/meals/list",
  createMeal: "/meals/create",
  editMeal: "/meals/:id/edit",
  mealsByDate: "/meals/date",
  mealCalendar: "/meals/calendar",

  //HRM
  employeeList: "/employees",
  employeeGrid: "/employees-grid",
  deviceConflicts: "/employees/device-conflicts",
  departments: "/departments",
  designations: "/designations",
  policy: "/policy",
  holidays: "/hrm/holidays",
  leaveadmin: "/leaves",
  leaveemployee: "/leaves-employee",
  leaveemployee2: "/leaves-employee2",
  leavesettings: "/leave-settings",
  attendanceadmin: "/attendance-admin",
  attendanceemployee: "/attendance-employee",
  timesheet: "/timesheets",
  scheduletiming: "/schedule-timing",
  overtime: "/overtime",
  promotion: "/promotion",
  resignation: "/resignation",
  termination: "/termination",
  // RECRUITMENT
  jobgrid: "/job-grid",
  joblist: "/job-list",
  candidatesGrid: "/candidates-grid",
  candidateslist: "/candidates",
  candidateskanban: "/candidates-kanban",
  refferal: "/refferals",
  //FINANCE & ACCOUNTS
  estimate: "/estimates",
  invoices: "/invoices",
  addinvoice: "/add-invoices",
  editinvoice: "/edit-invoices",
  invoicesdetails: "/invoice-details",
  payments: "/payments",
  expenses: "/expenses",
  providentfund: "/provident-fund",
  taxes: "/taxes",
  invoiceDetails: "/invoice-details",
  employeesalary: "/employee-salary",
  payslip: "/payslip",
  payrollAddition: "/payroll",
  payrollOvertime: "/payroll-overtime",
  payrollDeduction: "/payroll-deduction",
  //ADMINISTRATION
  knowledgebase: "/knowledgebase",
  activity: "/activity",
  users: "/users",
  rolePermission: "/roles-permissions",
  permissionpage: "/permission",
  assetCategories: "/asset-categories",
  assetList: "/assets",
  //Report
  expensesreport: "/expenses-report",
  invoicereport: "/invoice-report",
  paymentreport: "/payment-report",
  projectreport: "/project-report",
  taskreport: "/task-report",
  userreport: "/user-report",
  employeedetails: "/employee-details/:id",
  payslipreport: "/payslip-report",
  attendancereport: "/attendance-report",
  leavereport: "/leave-report",
  dailyreport: "/daily-report",
  //TICKETS
  ticketAdmin: "/tickets/ticket-admin",
  ticketEmployee: "/tickets/ticket-employee",
  userAttendance: "/user-attendance",
  userBreak: "/user-break",
  userLeaves: "/user-leaves",
  userTickets: "/user-tickets",
  forgotCheckOut: "/forgot-check-out",
  createCompany: "/create-company",
  forgotCheckIn: "/forgot-check-in",
  companyDocuments: "/company-documents",

  // Payment callback routes
  paymentCallback: "/subscription/callback",
  subscriptionCallback: "/subscription/callback-internal",
  smsCallback: "/sms-purchase-result",

  // Company Reports
  companyReport: "/reports/company",
  payrollReport: "/reports/payroll",

  // Super Admin Broadcast
  superAdminBroadcast: "/admin/broadcast",
  
  // Super Admin User Management
  superAdminUsers: "/superadmin/users",
  superAdminUserCreate: "/superadmin/users/create",
  superAdminUserEdit: "/superadmin/users/:id/edit",

  // Cihaz Çakışma Logları
  superAdminDeviceConflicts: "/superadmin/device-conflicts",

  // Field Management (Personel Aktiviteleri)
  personelActivities: "/personel-activities",
  personelActivitiesUser: "/personel-activities/:userId",
  personelActivityDetails: "/personel-activities/:id",
  vehicles: "/vehicles",
  vehicleDetails: "/vehicles/:id",
  
  // Overtime Management (Fazla Mesai Yönetimi)
  overtimePending: "/overtime/pending",
  overtimeHistory: "/overtime/history",

  // Field Mode Requests (Saha Modu Talepleri)
  fieldModeRequests: "/field-mode-requests",

  // Activity Requests (Onay bekleyen saha aktivitesi talepleri)
  activityRequests: "/activity-requests",

  // Onaylar (admin / yönetici birleşik onay kutusu)
  approvals: "/approvals",

  // Bildirimlerim (kullanıcıya gönderilen bildirimler - tüm roller)
  myNotifications: "/my-notifications",
};
